import { useEffect, useState } from 'react';

// Matches the breakpoint already used by other responsive Dialog/Drawer
// modals in this app (e.g. TestAnalysisDemo/components/DownloadAnalysisModal).
export function useIsTablet() {
  const [isTablet, setIsTablet] = useState(true);

  useEffect(() => {
    const checkIfTablet = () => setIsTablet(window.innerWidth > 1024);
    checkIfTablet();
    window.addEventListener('resize', checkIfTablet);
    return () => window.removeEventListener('resize', checkIfTablet);
  }, []);

  return isTablet;
}
